import { useEffect } from 'react';

/**
 * Hook to prevent browser swipe navigation (back/forward)
 * 
 * This hook adds event listeners to block horizontal swipe gestures
 * that would trigger browser navigation history.
 */
export const usePreventSwipeNavigation = () => {
  useEffect(() => {
    // Track touch start position
    let startX = 0;
    let startY = 0;
    
    // Handle touch start event
    const handleTouchStart = (e: TouchEvent) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    };
    
    // Handle touch move event
    const handleTouchMove = (e: TouchEvent) => {
      if (!e.touches || e.touches.length === 0) {
        return;
      }
      
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      
      // Calculate horizontal and vertical distance
      const diffX = startX - currentX;
      const diffY = startY - currentY;
      
      // If horizontal swipe is greater than vertical swipe and exceeds threshold
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
        // Prevent default behavior
        e.preventDefault();
      }
    };
    
    // Add event listeners
    document.addEventListener('touchstart', handleTouchStart, { passive: false });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    
    // Remove event listeners on cleanup
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []); // Empty dependency array means this effect runs once on mount
};
